import { createApp } from "vue";
import "bootstrap/scss/bootstrap.scss";
import "./styles/styles.scss";
// import $ from "jquery";
import router from "./router";
import store from "./store/index";
import i18n from "./i18n";
// import Map from "@arcgis/core/Map";
import ResponsiveTable from "./plugins/responsiveTable.js";
import Translations from "./plugins/translations";
import Default from "./layouts/Default.vue";
import NoSidebar from "./layouts/NoSidebar.vue";
import axios from "axios";
import Notify from "@/components/notify/notify.vue";
import { replaceVariables } from "@/filters/replaceVariables";
import dateTimeFilters from "@/filters/dateTimeFilters";
import { stringFilters } from "@/filters/stringFilters";
import { beforeTime } from "@/filters/beforeTime";
import { inflection } from "@/filters/inflection";
import { phone } from "@/filters/phone";
import App from "./App.vue";
import { cookieBot } from "@ambitiondev/vue-cookiebot";
import { createPinia } from "pinia";
import { Fetcher } from "openapi-typescript-fetch";
import vClickOutside from "click-outside-vue3";
import tooltip from "@/plugins/tooltip";
import { useConfigStore } from "@/store/modules/config";
import { useAuthStore } from "@/store/modules/auth";
const app = createApp(App);
app.use(cookieBot, {
    cookieBotId: "b1057658-78ec-4806-93e2-31945c421d41"
});
//import mgr from "@/services/security.js";
app.component("default-layout", Default);
app.component("no-sidebar-layout", NoSidebar);
app.component("notify", Notify);
// app.config.productionTip = false
// export const client = createPathBasedClient<paths>({ baseUrl: process.env.VUE_APP_API })
export const client = Fetcher.for();
client.configure({
    baseUrl: process.env.VUE_APP_API
});
const onFulfilled = (response) => {
    console.log("response");
    console.log(response);
    if (response.config.url === process.env.VUE_APP_API + "/customers?sort=%2BcustomerName&limit=1000" &&
        response.data.data.length < 1) {
        console.log("response.data.data.length < 1");
        if (response.data.data.length < 1) {
            const configStore = useConfigStore();
            configStore.isCustomersErrorVisible = true;
        }
    }
    return response;
};
// Single-flight refresh: concurrent 401s share one reLogin/authenticate cycle
// instead of spawning N parallel silent-renew iframes and N stacked redirects.
let inflightRefresh = null;
const refreshAuth = async () => {
    if (inflightRefresh)
        return inflightRefresh;
    const authStore = useAuthStore();
    const currentPath = router.currentRoute.value.path;
    const localVariableString = process.env.VUE_APP_AUTHORITY + ":" + process.env.VUE_APP_CLIENT_ID;
    inflightRefresh = (async () => {
        localStorage.removeItem(`oidc.user:${localVariableString}`);
        const renewed = await authStore.reLogin(currentPath);
        if (!renewed) {
            await authStore.authenticate(currentPath);
        }
        return renewed;
    })();
    try {
        return await inflightRefresh;
    }
    finally {
        inflightRefresh = null;
    }
};
const onRejected = async (error) => {
    const authStore = useAuthStore();
    const configStore = useConfigStore();
    if (error.response?.status === 401) {
        const localVariableString = process.env.VUE_APP_AUTHORITY + ":" + process.env.VUE_APP_CLIENT_ID;
        const oidcUserRaw = localStorage.getItem(`oidc.user:${localVariableString}`);
        const oidcUser = oidcUserRaw ? JSON.parse(oidcUserRaw) : null;
        if (oidcUser?.access_token) {
            const reloaded = localStorage.getItem("reloaded");
            if (reloaded === "true") {
                localStorage.removeItem("reloaded");
                await authStore.signOut();
            }
            else {
                configStore.isTokenErrorVisible = true;
            }
        }
        else {
            const renewed = await refreshAuth();
            if (renewed && error.config) {
                // Token was silently renewed — retry the original request transparently.
                return axios(error.config);
            }
        }
    }
    else if (error.response?.status === 402 || error.response?.status === 403) {
        if (error.response.config.url === process.env.VUE_APP_API + "/customers?sort=%2BcustomerName&limit=1000") {
            configStore.isPermissionErrorVisible = true;
        }
    }
    else if (error.response?.config.url === process.env.VUE_APP_AUTHORITY + "protocol/openid-connect/token") {
        configStore.isTokenErrorVisible = true;
    }
    throw error.response;
};
axios.interceptors.response.use(onFulfilled, onRejected);
client.use(async (url, init, next) => {
    try {
        const response = await next(url, init);
        onFulfilled({ ...response, config: { url: response.url } });
        return response;
    }
    catch (error) {
        if (error?.status === 401) {
            const localVariableString = process.env.VUE_APP_AUTHORITY + ":" + process.env.VUE_APP_CLIENT_ID;
            const oidcUserRaw = localStorage.getItem(`oidc.user:${localVariableString}`);
            const oidcUser = oidcUserRaw ? JSON.parse(oidcUserRaw) : null;
            if (!oidcUser?.access_token) {
                const renewed = await refreshAuth();
                if (renewed) {
                    // Retry once with the refreshed Authorization header.
                    const retried = await next(url, init);
                    onFulfilled({ ...retried, config: { url: retried.url } });
                    return retried;
                }
            }
        }
        await onRejected({ response: { ...error, config: { url } }, config: init });
        throw error;
    }
});
const pinia = createPinia();
app.use(pinia);
app.use(Translations, {});
app.use(ResponsiveTable, {});
app.use(vClickOutside, {});
app.use(store);
// app.use(Map)
app.use(i18n);
// app.use($)
app.use(router);
app.directive("tooltip", tooltip);
app.config.globalProperties.$filters = {
    ...dateTimeFilters,
    replaceVariables,
    ...stringFilters,
    beforeTime,
    inflection,
    phone
};
app.mount("#app");
// new Vue({
//   el: "#app",
//   router,
//   store,
//   i18n,
//   $,
//   Map,
//   render: h => h(App)
// });
